import moment from 'moment'
import { EventI, NewEventI } from 'types/calendarTypes'

export const prepareDataEvent = (payload: NewEventI, id: number) => {
  const {
    title,
    dateStart,
    dateEnd,
    timeStart,
    timeEnd,
    candidate,
    comment,
    job,
    zoom,
    zoomMeetingNumber,
    zoomMeetingPassword
  } = payload
  const start = new Date(dateStart.setHours(timeStart.getHours(), timeStart.getMinutes(), 0, 0))
  const end = new Date(dateEnd.setHours(timeEnd.getHours(), timeEnd.getMinutes(), 0, 0))

  return {
    title,
    start,
    end,
    candidateId: candidate && candidate.value,
    jobId: job ? job.value : undefined,
    comment: comment || undefined,
    managerId: id,
    zoomMeetingNumber: zoom ? zoomMeetingNumber : null,
    zoomMeetingPassword: zoom ? zoomMeetingPassword : null
  }
}

export const prepareEventsList = (data: EventI[]) => {
  const dateOfToday = moment()
  let nearestEvent: EventI | undefined
  const events = data.map(item => {
    if (
      !item.rendering &&
      !moment(item.start).isBefore(dateOfToday) &&
      (!nearestEvent || moment(item.start).isBefore(moment(nearestEvent.start)))
    ) {
      nearestEvent = item
    }
    const rendering = item.rendering === 'background' ? 'unavailability' : null
    return { ...item, rendering }
  })
  return {
    events,
    nearestEventId: nearestEvent && nearestEvent.id
  }
}
